import { MY_POSTS } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = MY_POSTS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    method: 'addSection',
    social: false,
    showInLoginMenu: true,
    urlOverride: 'my-posts',
    menuOrder: 2,
    visibleForRoles: ['admin', 'blog_writer', 'blog_editor', 'blog_guest_writer'],
    page: {
        name: t('member-pages.my-posts.name'),
        shortDescription: t('member-pages.my-posts.short-description'),
        description: formatDescription({
            text: t('member-pages.my-posts.description.text'),
            bulletPoints: [
                t('member-pages.my-posts.description.bullet-point-1'),
                t('member-pages.my-posts.description.bullet-point-2'),
                t('member-pages.my-posts.description.bullet-point-3'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/blog-icon.png`,
        origin: t('member-pages.origin'),
        isNew: true,
        screenshots: [
            `${staticsUrl}assets/images/my-posts/my-posts.png`,
            `${staticsUrl}assets/images/my-posts/mobile-my-posts.png`,
        ],
    },
});
//# sourceMappingURL=my-posts.js.map